/**
 * WEB-CORE-07 (review 7): the ONE statement of the codec a Studio export is encoded with -- the card's option echo and the
 * export sheet's "Format" row read it, never a literal of their own. The Studio request carries no `videoCodec`: the edge
 * decides, and ironman's compose picks its encoder from `H264_PREFERENCE` and REFUSES to render without an H.264 encoder
 * (`FfmpegCapabilities.selectEncoder`, including the iGPU `h264_vaapi` path). `output-format.spec.ts` reads that source,
 * so an edge that stops being H.264-only fails the build here instead of the card silently saying H264.
 */
export const STUDIO_VIDEO_CODEC = 'H264';

/** The same codec as a person reads it ("MP4 (H.264)"). */
export const STUDIO_VIDEO_CODEC_LABEL = 'H.264';
